import { create } from 'zustand';

/** The open channel's message box, so the profile card's "Bahset" can write into it. */
export const useComposer = create<{ channelId: string | null; insert: string | null }>(() => ({ channelId: null, insert: null }));

/** Adds "@Ad Soyad " where the caret is; the box turns it into a mention when sending. */
export const mentionInComposer = (name: string) => useComposer.setState({ insert: `@${name} ` });
